(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duffed-campaign-slider"] && !Shopify.designMode) return;
  try {
    
function initialiseCampaignSliders(scope=document){
  for(const slider of scope.querySelectorAll('[data-campaign-slider]:not([data-campaign-bound])')){
    slider.dataset.campaignBound='true';
    const track=slider.querySelector('[data-campaign-track]');
    const slides=Array.from(slider.querySelectorAll('[data-campaign-slide]'));
    const dots=Array.from(slider.querySelectorAll('[data-campaign-dot]'));
    const pause=slider.querySelector('[data-campaign-pause]');
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    if(!window.Shopify?.designMode){
      const labels=slides.map(slide=>slide.getAttribute('aria-label'));
      const dotLabels=dots.map(dot=>dot.getAttribute('aria-label'));
      for(let i=slides.length-1;i>0;i--){
        const j=Math.floor(Math.random()*(i+1));
        [slides[i],slides[j]]=[slides[j],slides[i]];
        [dots[i],dots[j]]=[dots[j],dots[i]];
      }
      slides.forEach((slide,i)=>{
        track.append(slide);
        slide.setAttribute('aria-label',labels[i]);
        dots[i].dataset.campaignDot=String(i);
        dots[i].setAttribute('aria-label',dotLabels[i]);
        dots[i].parentElement.append(dots[i]);
      });
    }
    slides.forEach((slide,i)=>{
      const photo=slide.querySelector('.df-campaign-photo');
      if(photo){photo.loading='eager';photo.fetchPriority=i===0?'high':'low';}
    });
    track.scrollTo({left:0,behavior:'instant'});
    let current=0,timer,scrollTimer,paused=slider.dataset.autoplay!=='true'||reduce.matches,visible=true;
    const update=()=>{
      current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
      slides.forEach((slide,i)=>{slide.inert=i!==current;slide.setAttribute('aria-hidden',String(i!==current));});
      dots.forEach((dot,i)=>{if(i===current)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      slider.querySelector('[data-campaign-status]').setAttribute('aria-live',paused?'polite':'off');
      slider.querySelector('[data-campaign-status]').textContent=slides[current]?.getAttribute('aria-label')||'';
    };
    const go=index=>{const next=(index+slides.length)%slides.length;track.scrollTo({left:next*track.clientWidth,behavior:reduce.matches?'instant':'smooth'});};
    const schedule=()=>{clearInterval(timer);pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.textContent=paused?'▷':'Ⅱ';if(!paused&&visible&&!document.hidden&&!reduce.matches)timer=setInterval(()=>go(current+1),4000);};
    const stop=()=>{paused=true;schedule();};
    track.addEventListener('scroll',()=>{clearTimeout(scrollTimer);scrollTimer=setTimeout(update,90);},{passive:true});
    track.addEventListener('pointerdown',stop);
    slider.addEventListener('focusin',event=>{if(event.target!==pause)stop();});
    track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();stop();go(current+(event.key==='ArrowRight'?1:-1));}});
    for(const button of slider.querySelectorAll('[data-campaign-step]'))button.addEventListener('click',()=>{stop();go(current+Number(button.dataset.campaignStep));});
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{stop();go(i);}));
    pause.addEventListener('click',()=>{paused=!paused;schedule();});
    document.addEventListener('visibilitychange',schedule);
    reduce.addEventListener('change',()=>{if(reduce.matches)paused=true;schedule();});
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15}).observe(slider);
    window.addEventListener('resize',()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});update();});
    slider.querySelector('[data-campaign-controls]').hidden=slides.length<2;update();schedule();
  }
}
initialiseCampaignSliders();
document.addEventListener('shopify:section:load',event=>initialiseCampaignSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-collection"]) return;
  try {
    
function initialiseStreetCollections(scope=document){
  for(const opener of scope.querySelectorAll('[data-filter-open]:not([data-filter-bound])')){
    opener.dataset.filterBound='true';
    const drawer=document.getElementById(opener.getAttribute('aria-controls'));
    opener.addEventListener('click',()=>{drawer.showModal();opener.setAttribute('aria-expanded','true');document.documentElement.classList.add('df-scroll-lock');});
    drawer.querySelector('[data-filter-close]').addEventListener('click',()=>drawer.close());
    drawer.addEventListener('click',event=>{const rect=drawer.getBoundingClientRect();if(event.target===drawer&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))drawer.close();});
    drawer.addEventListener('close',()=>{opener.setAttribute('aria-expanded','false');document.documentElement.classList.remove('df-scroll-lock');opener.focus();});
  }
  for(const form of scope.querySelectorAll('[data-street-sort]:not([data-sort-bound])')){
    form.dataset.sortBound='true';form.querySelector('[data-sort-submit]').hidden=true;
    form.querySelector('select').addEventListener('change',()=>form.requestSubmit());
  }
}
initialiseStreetCollections();
document.addEventListener('shopify:section:load',event=>initialiseStreetCollections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-header"]) return;
  try {
    
function initialiseStreetHeaders(scope=document){
  for(const header of scope.querySelectorAll('[data-street-header]:not([data-menu-bound])')){
    header.dataset.menuBound='true';
    const opener=header.querySelector('[data-menu-open]');
    const menu=document.getElementById(opener.getAttribute('aria-controls'));
    const pageScroller=document.querySelector('.page-wrapper');
    const update=()=>header.classList.toggle('is-solid',Math.max(window.scrollY,pageScroller?.scrollTop||0)>35);
    update();window.addEventListener('scroll',update,{passive:true});pageScroller?.addEventListener('scroll',update,{passive:true});
    opener.addEventListener('click',()=>{menu.showModal();opener.setAttribute('aria-expanded','true');document.documentElement.classList.add('df-scroll-lock');});
    menu.querySelector('[data-menu-close]').addEventListener('click',()=>menu.close());
    menu.addEventListener('click',event=>{const rect=menu.getBoundingClientRect();if(event.target===menu&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))menu.close();});
    menu.addEventListener('close',()=>{opener.setAttribute('aria-expanded','false');document.documentElement.classList.remove('df-scroll-lock');opener.focus();});
  }
}
initialiseStreetHeaders();
document.addEventListener('shopify:section:load',event=>initialiseStreetHeaders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-hole-edit"] && !Shopify.designMode) return;
  try {
    
function initialiseCoastalEdits(scope=document){
  for(const edit of scope.querySelectorAll('[data-coastal-edit]:not([data-coastal-bound])')){
    edit.dataset.coastalBound='true';
    const links=Array.from(edit.querySelectorAll('[data-coastal-hole]'));
    const panels=Array.from(edit.querySelectorAll('[data-coastal-panel]'));
    if(!links.length)continue;
    let selected=0;
    const show=(index)=>{
      selected=(index+links.length)%links.length;
      links.forEach((link,i)=>{if(i===selected)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
      panels.forEach((panel,i)=>{panel.hidden=i!==selected;});
      const number=String(selected+1).padStart(2,'0');
      edit.querySelector('[data-coastal-number]').textContent=number;
      edit.querySelector('[data-coastal-progress]').textContent=number;
    };
    links.forEach((link,i)=>{
      link.addEventListener('click',event=>{event.preventDefault();show(i);});
      link.addEventListener('keydown',event=>{
        let target;
        if(event.key==='ArrowRight')target=(i+1)%links.length;
        if(event.key==='ArrowLeft')target=(i+links.length-1)%links.length;
        if(event.key==='Home')target=0;
        if(event.key==='End')target=links.length-1;
        if(target!==undefined){event.preventDefault();show(target);links[target].focus();}
      });
    });
    for(const button of edit.querySelectorAll('[data-coastal-step]'))button.addEventListener('click',()=>show(selected+Number(button.dataset.coastalStep)));
    edit.querySelector('[data-coastal-controls]').hidden=false;
  }
}
initialiseCoastalEdits();
document.addEventListener('shopify:section:load',event=>initialiseCoastalEdits(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-links-motion"] && !Shopify.designMode) return;
  try {
    
function initialiseDuffedMotion(scope = document) {
  scope.querySelectorAll('.df-motion-stage:not([data-motion-bound])').forEach(stage => {
    stage.dataset.motionBound = 'true';
    const button = stage.querySelector('.df-motion-toggle');
    const video = stage.querySelector('video');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let visible = false;
    function update() {
      const playing = visible && !userPaused && !reducedMotion.matches && !document.hidden;
      stage.dataset.motionState = playing ? 'playing' : 'paused';
      button.hidden = reducedMotion.matches;
      button.setAttribute('aria-pressed', String(userPaused));
      button.textContent = userPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
      if (video) {
        if (playing) video.play().catch(() => { userPaused = true; update(); });
        else video.pause();
      }
    }
    button.addEventListener('click', () => { userPaused = !userPaused; update(); });
    reducedMotion.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      update();
    }, { threshold: 0.15 });
    observer.observe(stage);
    update();
  });
}
initialiseDuffedMotion();
document.addEventListener('shopify:section:load', event => initialiseDuffedMotion(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-product-help"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-df-share]');
  if (!button) return;
  const status = button.parentElement.querySelector('[data-df-share-status]');
  try {
    if (navigator.share) await navigator.share({ title: button.dataset.title, url: button.dataset.url });
    else { await navigator.clipboard.writeText(button.dataset.url); status.textContent = button.dataset.copied; }
  } catch (error) { if (error.name !== 'AbortError') status.textContent = button.dataset.failed; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duffed-scorecard"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const pin = event.target.closest('[data-df-hole]');
  if (!pin) return;
  const round = pin.closest('[data-df-round]');
  if (!round) return;
  event.preventDefault();
  for (const marker of round.querySelectorAll('[data-df-hole]')) marker.removeAttribute('aria-current');
  pin.setAttribute('aria-current', 'true');
  for (const panel of round.querySelectorAll('[data-df-panel]')) panel.hidden = panel.dataset.dfPanel !== pin.dataset.dfHole;
  if (matchMedia('(max-width: 999px)').matches) round.querySelector('.df-course-feature').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
